﻿export default class SpeedcurveEventType {
  /**
   * This is a static method that returns an instance of the "Conversion" class.
   * @returns The `Conversion` instance is being returned. It is obtained by calling the `getInstance`
   * method of the current class (`this`) and passing in the string `'Conversion'` as an argument.
   */
  static get Conversion() {
    return this.getInstance('Conversion');
  }

  /**
   * This is a static method that returns an instance of the "MarkStart" class.
   * @returns The `MarkStart` instance is being returned. It is obtained by calling the `getInstance`
   * method of the current class (`this`) and passing in the string `'MarkStart'` as an argument.
   */
  static get MarkStart() {
    return this.getInstance('MarkStart');
  }

  /**
   * This is a static method that returns an instance of the "MarkEnd" class.
   * @returns The `MarkEnd` instance is being returned. It is obtained by calling the `getInstance`
   * method of the current class (`this`) and passing in the string `'MarkEnd'` as an argument.
   */
  static get MarkEnd() {
    return this.getInstance('MarkEnd');
  }

  /**
   * This is a static method that returns an instance of the "TimingMetric" class.
   * @returns The `TimingMetric` instance is being returned. It is obtained by calling the `getInstance`
   * method of the current class (`this`) and passing in the string `'TimingMetric'` as an argument.
   */
  static get TimingMetric() {
    return this.getInstance('TimingMetric');
  }

  /**
   * The function returns a value from a map based on the input name.
   *
   * @param name - The name of the key in the `statusMap` object that we want to retrieve the value for.
   *
   * @returns the value of the `statusMap` object that corresponds to the `name` parameter passed to the function.
   * If `name` matches one of the keys in `statusMap`, the corresponding value is returned.
   */
  static fromKey(key) {
    const statusMap = {
      Conversion: SpeedcurveEventType.Conversion,
      MarkStart: SpeedcurveEventType.MarkStart,
      MarkEnd: SpeedcurveEventType.MarkEnd,
      TimingMetric: SpeedcurveEventType.TimingMetric,
    };
    return statusMap[key];
  }

  /**
   * Gets an instance of a SpeedcurveEventType object based on a given name.
   * If the instance does not already exist, it creates a new instance using the configuration provided.
   *
   * @param name a unique identifier used to retrieve or create an instance of the SpeedcurveEventType class.
   * @param configuration an object that contains various properties and values that are used to configure
   * the instance of the SpeedcurveEventType class that is being created.
   *
   * @returns an instance of `SpeedcurveEventType` that corresponds to the given `name`.
   */
  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new SpeedcurveEventType(key);
    }
    return this.instances[key];
  }

  /**
   * This is a constructor function that takes a name as a parameter and sets the name
   * @param name -The `name` property is a string that represents the name of the
   * configuration
   */
  constructor(name) {
    this.name = name;
  }

  /**
   * Method that returns the name property of an object as a string.
   * @returns returns the `name` property of that object as a string.
   */
  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(SpeedcurveEventType, 'instances', { value: {} });
